import {createHeaderUI, HeaderUI} from './headerUI';
const STICKY_BREAKPOINT: number = 50;

export class Header {
    public constructor(private ui: HeaderUI) {
        this.ui.onScroll(this.toggleSticky.bind(this))
        this.ui.clickDropdownLink();
        this.ui.clickDropdownArrow();
    }

    public toggleSticky() {
      if(this.ui.getScrollTop() >= STICKY_BREAKPOINT) {
          this.ui.addStickyClass();
          this.ui.allowFadeOut = true;
      }
      else {
        this.ui.removeStickyClass();
      }
    }
}

export function initHeader() {
    const uiInstance = createHeaderUI();
    const instance = uiInstance.map((uiInstance: HeaderUI) => {
        return new Header(uiInstance);
    });
}

